import styled from 'styled-components';
import Button from '@prisjakt/ui-button';

export const SwitchButton = styled(Button)`
  position: absolute;
  top: 40%;
  background: ${p => p.theme.buttons.panning.bg};
  z-index: 1;
  opacity: 0;
  transition: opacity 0.5s;
  color: ${p => p.theme.buttons.panning.text};

  && {
    svg {
      path {
        fill: ${p => p.theme.buttons.panning.text};
      }
    }
  }

  &&:hover,
  &&:focus {
    background: ${p => p.theme.buttons.panning.bgHover};
  }
`;

export const Carousel = styled.div.attrs({ 'data-test': 'Carousel' })`
  &:hover {
    ${SwitchButton} {
      opacity: 1;
    }
  }
`;
